import { Eye, EyeOff, Loader, X } from "lucide-react";
import React, { useEffect, useState } from "react";
import { notify, getPractice } from "../../helpers";
import { getOtpSettings, setupOTP } from "../../services/users";
import Spacing from "../Spacing";


export default function SetupOTPModal(props) {
  const { activeModal, setActiveModal = () => { } } = props;

  const [enableLoader, setEnableLoader] = useState(false);
  const [error, setError] = useState("");

  const [informations, setInformations] = useState({
    account_id: getPractice("account_id"),
    otp_bool: "",
    // otp_type: ""
  });

  const handleChange = (e) => {
    setInformations({ ...informations, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.target.disabled = true;
    setEnableLoader(true);

    try {
      const result = await setupOTP(informations);

      if (result.data.status === "error") {
        notify("error", result?.data?.message);
      } else {
        notify("success", result?.data?.message);
        setActiveModal(!activeModal);
      }
    } catch (error) {
      notify("error", "Error setting up OTP");
    } finally {
      setEnableLoader(false);
      e.target.disabled = false;
    }
  }
  console.log(informations);
  useEffect(() => {
    const fetchOtpSettings = async()=>{
      const data = await getOtpSettings();
      if(data?.data){
        console.log(data?.data.otp_bool);
        setInformations({...informations, otp_bool: data?.data.otp_bool.toString()});
    

      }
    }
    fetchOtpSettings()
  }, [])

  return (
    <>
      {activeModal && (
        <div className="docpro_modal_wrap">
          <div className="docpro_modal_overlay"></div>
          <div className="docpro_modal relative" style={{ maxWidth: "435px"}}>
            <div className="absolute right-0 top-0 p-3 pointer mt-1 mr-1" onClick={() => setActiveModal(!activeModal)}>
              <X width={18} height={18} />
            </div>

            <div className="docpro_login_card_wrap">
              <form onSubmit={handleSubmit} className="docpro_login_card" style={{ maxWidth: "435px" }}>
                <div className="docpro_text_center">
                  <h1 className="docpro_mb_0">2FA Setting</h1>
                </div>
                <Spacing lg="30" sm="30" />

                <label className="docpro_fw_500 docpro_primary_color">
                  Enable OTP <span className="docpro_red_color">*</span>
                </label>
                <div className="docpro_form_field_with_icon flex">
                  <label className="flex mr-4">
                    <input
                      name="otp_bool"
                      type="radio"
                      value="true"
                      checked={informations.otp_bool === "true"}
                      //   className="docpro_form_field size_lg"
                      onChange={handleChange}
                      required
                      className="mr-2"
                    />
                    Enabled
                  </label>
                  <label className="flex">
                    <input
                      name="otp_bool"
                      type="radio"
                      value="false"
                      checked={informations.otp_bool === "false"}
                      //   className="docpro_form_field size_lg"
                      onChange={handleChange}
                      required
                      className="mr-2"
                    />
                    Disabled
                  </label>
                </div>

                {/* <label className="docpro_fw_500 docpro_primary_color">
                  Select Delivery Method <span className="docpro_red_color">*</span>
                </label>
                <div className="docpro_form_field_with_icon">
                  <select
                    name="otp_type"
                    className="docpro_form_field size_lg"
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select...</option>
                    <option value="phone">Phone</option>
                    <option value="message">E-mail</option>
                  </select>
                </div> */}

                {error && <div style={{ color: "red" }}>{error}</div>}
                <button
                  type="submit"
                  className="docpro_bordered_btn mt-2 size_lg width_100 docpro_fw_600 docpro_white_color docpro_filed_btn"
                >
                  <span>Submit</span>
                </button>
              </form>
            </div>

            {enableLoader && (
              <div
                className="absolute top-0 left-0 flex items-center loading"
                style={{ width: "100%", height: "100%", justifyContent: "center", backgroundColor: "rgb(230 230 230 / 70%)", borderRadius: "12px" }}
              >
                <span className="docpro_loading">
                  <Loader width={42} height={42} style={{ color: "var(--accent)" }} />
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
